import DoAPICall from './DoAPICall'

//Create group
    export async function createGroup(userToken, group){
        const apiPayload = {
            httpMethod:'post',
            userToken,
            uri:'groups',
            payLoad:{
                client_id:group.client_id,
                name:group.name,
                description:group.description
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get All group
    export async function getGroups(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'groups',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }
//Get Rights of the group
    export async function getGroupsOfClient(userToken, client_id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'groupsofclient/'+client_id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }
//Get One group
    export async function getGroup(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'groups/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get Rights of the group
    export async function getRightsOfGroup(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'rightsofgroup/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }


//Update group
    export async function updateGroup(userToken, group){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'groups/'+group.id,
            payLoad:{
                name:group.name,
                description:group.description,
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Delete group
    export async function deleteGroup(userToken, id){
        const apiPayload = {
            httpMethod:'delete',
            userToken,
            uri:'groups/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }




